import { Dispatch, SetStateAction } from "react";
import Plus from "../../assets/icons/Plus";

interface AttendancePageSwapper {
    selectedPage: string;
    setSelectedPage: Dispatch<SetStateAction<string>>;
    pages: string[];
    onAddCourse?: () => void;
}

export default function AttendancePageSwapper({selectedPage, setSelectedPage, pages, onAddCourse} : AttendancePageSwapper) {
  const onPageClick = (page: string) => {
    setSelectedPage(page)
  }
  return (
    <div>
        {/* button back */}
        <div></div>
        {/* swapper */}
        <div className="flex w-full bg-white px-4 py-2 rounded-xl gap-3 items-center">
            <div className="font-medium text-sm flex items-center text-valley-gray">
                Курс
            </div>
            <div className="flex-1 flex gap-3">
              {pages.map(p => (
                  <SwapperItem key={p} label={p} isSelected={p === selectedPage}
                  onClick={onPageClick}/>
              ))}
              {onAddCourse && (
              <button
                onClick={onAddCourse}
                className="flex items-center justify-center w-8 h-8 rounded-lg bg-valley-background-blue hover:bg-valley-blue/20 cursor-pointer transition-colors"
                title="Добавить курс"
              >
                <Plus additionalStyle="text-valley-gray" />
              </button>
            )}
            </div>
            
        </div>
    </div>
  )
}

interface SwapperItemProps {
    label: string;
    isSelected: boolean;
    onClick : (page: string) => void;
    // onDelete: () => {} : void
}

const SwapperItem = ({label, isSelected, onClick} : SwapperItemProps) => {
    const style = !isSelected ? 
    {
        bg: 'bg-valley-background-blue',
        text: 'black'
    } : 
    {
        bg: 'bg-valley-main',
        text: 'white'
    }
    return (
        <div 
        className={`${style.bg} text-${style.text} rounded-lg px-2 py-1 cursor-pointer`} 
        onClick={() => onClick(label)}>
            {label}
        </div>
    )
}
